<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import VerificationCode from "@/components/modals/verification-code.vue";
import BursList from '@/components/widgets/burs-list.vue';
import DisbursementList from "@/components/widgets/disbursement-list.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import DisbursementModal from "@/components/modals/disbursement-modal.vue";
import FinanceAttachments from "@/components/modals/finance-attachments.vue";
import BursModal from "@/components/modals/burs-modal.vue";
import Swal from "sweetalert2";

export default {
    page: {
        title: "Disbursement",
    },
    components: {
        Layout,
        PageHeader,
        VerificationCode,
        BursList,
        DisbursementList,
        PrintOptions,
        DisbursementModal,
        FinanceAttachments,
        BursModal,
    },
    data() {
        return {
            title: "Disbursement",
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Disbursement",
                    active: true,
                },
            ],
            loading: false,
            disbursementData: [],
            banks: [],
            accounts: [],
            tabModel: 0,
            selectedBurs: null,
            modalTitle: "Disbursement",
            bursData: [],
            journals: [],
            fundSources: [],
            selectedDVs: null,
            selectedJournal: ''
        };
    },
    watch: {
        tabModel: function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.changeData(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
            }
        },
    },
    created(){
        this.fetchBanks();
        this.fetchAccounts();
        this.changeData(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
    },
    methods: {
        async changeData(cycle, campusId) {
            this.loading = true;
            await this.getFundSources(campusId);
            if(this.tabModel == 0){
                await this.fetchAvailableDisbursement(cycle, campusId);
            }else if(this.tabModel == 1){
                this.disbursementData = [];
                await this.fetchPendingDisbursement(cycle, campusId);
            }else{
                this.disbursementData = [];
                await this.fetchPostedDisbursement(cycle, campusId);
            }
            this.loading = false;
        },
        async getFundSources(id){
            await this.$store
                .dispatch("fundsource/GetActiveFundSourcesByCampusId", id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.fundSources = res.data
                })
                .catch((err) => {
                    this.showToast("Failed to fetch fund sources. Please contact administrator", "error");
                });
        },
        async fetchAvailableDisbursement(cycle, campusId) {
            if(this.bursData.length !== 0) return;
            await this.$store.dispatch("disbursement/getAvailableBurs", { cycle, campusId })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.filterKey = item.serialNumber + ' ' + item.payee + ' ' + item.particulars;
                        item.viewDetails = false;
                        item.opened = false;
                        item.detailShow = true;
                        item.dvShow = false;
                    })
                    this.bursData = res.data;
                })
                .catch((err) => {
                    this.showToast('Error fetching available disbursement!', "error");
                });
        },
        async fetchPendingDisbursement(cycle, campusId) {
            await this.$store.dispatch("disbursement/getPendingDisbursements", { cycle, campusId })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.filterKey = `${item.accountNumber} ${item.bursSerialNumber} ${item.particulars}`;
                        item.opened = false;
                        item.selected = false;
                        item.disbursementItems.map(item => {
                            item.isEdit = false;
                            item.uacs = '';
                        })
                        item.showPopover = false;
                    })
                    this.disbursementData = res.data;
                })
                .catch((err) => {
                    this.showToast('Error fetching pending disbursement!', "error");
                });
        },
        async fetchPostedDisbursement(cycle, campusId) {
            await this.$store.dispatch("disbursement/getPostedDisbursements", { cycle, campusId })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.filterKey = `${item.accountNumber} ${item.bursSerialNumber} ${item.particulars}`;
                        item.opened = false;
                        item.selected = false;
                        item.disbursementItems.map(item => {
                            item.isEdit = false;
                            item.uacs = ''
                        })
                        item.showPopover = false;
                    })
                    this.disbursementData = res.data;
                })
                .catch((err) => {
                    this.showToast('Error fetching posted disbursement!', "error");
                });
        },
        async verifyNow(code) {
            await this.$store.dispatch("verification/verifyCode", {
                code: code,
                type: 'disbursement-posting',
            })
            .then((res) => {
                if (res.data.error) {
                    return { success: false, message: res.data.errorMessage}
                }
                this.$bvModal.hide("verify-modal");
                return { success: true, message: res.data}
            });
        },
        async fetchBanks(){
            await this.$store
                .dispatch("accounts/getAccountByAccountGroup", 2064)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.banks = res.data.filter(item => ![1402, 1403, 1404].includes(item.id));
                })
            .catch((error) => {
                this.showToast("Cannot fetch banks. Please contact your administrator", "error");
            });
        },
        async fetchAccounts(){
            await this.$store
                .dispatch("accounts/getAllAccounts")
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.accounts = res.data;
                })
            .catch((error) => {
                this.showToast("Cannot fetch accounts. Please contact your administrator", "error");
            });
        },
        createDisbursement(item) {
            this.selectedBurs = item;
            this.$refs.disbursementModal.resetForm();
            if(item.payeeId){
                this.$refs.disbursementModal.fetchPayeeInfo(item.payeeId);
            }else{
                this.$refs.disbursementModal.setPayeeInfo(item);
            }
            this.$refs.disbursementModal.fetchChargingInfo(item);
            this.$refs.disbursementModal.form.particulars = item.particulars;
            this.$refs.disbursementModal.amount = parseFloat(this.getExactAmt(item.total));
            this.modalTitle = "Create Disbursement";
            this.$bvModal.show("disbursement-modal");
        },
        submitDisbursement(modalData){
            if(modalData.id > 0){
                this.$store
                    .dispatch("disbursement/updateDisbursement", modalData)
                    .then((response) => {
                        if (response.data.error) return this.showToast(response.data.errorMessage, "error");
                        let index = this.disbursementData.findIndex(item => item.id === modalData.id);
                        this.disbursementData.splice(index, 1, modalData);
                        this.showToast("Disbursement updated successfully", "success");
                        this.$bvModal.hide("disbursement-modal");
                    })
                    .catch((error) => {
                        this.showToast("Error submitting!", "error");
                    });
            }else{
                modalData.amount = this.selectedBurs.total;
                modalData.bursId = this.selectedBurs.id;
                modalData.disbursementNumber = "";
                this.$store
                    .dispatch("disbursement/createDisbursement", modalData)
                    .then((response) => {
                        if (response.data.error) return this.showToast(response.data.errorMessage, "error");
                        let index = this.bursData.findIndex(item => item.id === this.selectedBurs.id);
                        this.bursData.splice(index, 1);
                        this.showToast("Disbursement created successfully", "success");
                        this.$bvModal.hide("disbursement-modal");
                    })
                    .catch((error) => {
                        this.showToast("Error submitting!", "error");
                    });
            }
        },
        printBurs(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "/api/Report/Finance/BURS",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        generateDV(item) {
            this.$refs.printOpt.putOptions({
                apiUrl: "/api/Report/Finance/Disbursement",
                routeVariables: [item.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        getAttachments(data){
            this.$refs.finAttach.setUploadOpt({
                type: "Disbursement",
                placement: "left",
                folder: "Finance",
            });
            this.$refs.finAttach.getAttachments(data.att, data.id);
            this.$bvModal.show("finance-attachment-modal");
        },
        returnDisbursement(item) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#ff9f43",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, return it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("disbursement/returnDisbursement", item.id)
                        .then((response) => {
                            if (response.data.error) return this.showToast(response.data.errorMessage, "error");
                            let index = this.disbursementData.findIndex(i => i.id === item.id);
                            this.disbursementData.splice(index, 1);
                            this.showToast("Disbursement returned successfully", "success");
                        })
                        .catch((error) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        editDisbursement(item) {
            this.$refs.disbursementModal.resetForm();
            this.$refs.disbursementModal.updateData(item);
            this.$refs.disbursementModal.amount = item.amount;
            this.modalTitle = "Edit Disbursement";
            this.$bvModal.show("disbursement-modal");
        },
        deleteDisbursement(item) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#ea5455",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("disbursement/deleteDisbursement", item.id)
                        .then((response) => {
                            if (response.data.error) return this.showToast(response.data.errorMessage, "error");
                            let index = this.disbursementData.findIndex(item => item.id === item.id);
                            this.disbursementData.splice(index, 1);
                            this.showToast("Disbursement deleted successfully", "success");
                        })
                        .catch((error) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        editBurs(item) {
            this.selectedBurs = item;
            this.$refs.bursModal.getRFPData(item.rfpId);
            this.$refs.bursModal.updateData({
                id: item.id,
                bursDate: new Date(item.bursDate),
                particulars: item.particulars,
                isDueAndDemandable: item.isDueAndDemandable,
            });
            this.modalTitle = "Update Obligation";
            this.$bvModal.show("burs-modal");
        },
        async submitBurs(modalData) {
            await this.$store
                .dispatch("burs/updateBurs", modalData)
                .then((res) => {
                    if (res.data.error) {
                    return this.showToast(res.data.errorMessage, "error");
                    }
                    let index = this.bursData.findIndex(item => item.id === modalData.id);
                    this.bursData.splice(index, 1, modalData);
                    this.showToast('Successfully updated', "success");
                    this.$bvModal.hide("burs-modal");
                })
                .catch((err) => {
                    this.showToast('Something went wrong!', "error");
                });
        },
        async approveDV({form, data}) {
            await this.$store
                .dispatch("disbursement/postDisbursement", {
                    dateTime: this.getDate(form.postDate),
                    id: data.id,
                })
                .then((response) => {
                    if (response.data.error) return this.showToast(response.data.errorMessage, "error");
                    let index = this.disbursementData.findIndex(item => item.id === data.id);
                    this.disbursementData.splice(index, 1);
                    this.showToast("Disbursement approved successfully", "success");
                    this.$bvModal.hide("disbursement-modal");
                })
                .catch((error) => {
                    this.showToast("Error approving!", "error");
                });
        },
    }
}
</script>
<template>
  <Layout @changeCycle="changeData($event, $store.state.data.selectedCampus.id)" @changeCampus="changeData($store.state.data.cycle, $event.id)">
    <PageHeader :title="title" :items="items" />
    <VerificationCode @dropCode="verifyNow" ref="verification" />
    <b-tabs
        v-model="tabModel"
        pills
        vertical
        nav-class="p-0"
        nav-wrapper-class="col-sm-2 border-end"
        content-class="pt-0 px-2 text-muted"
    >
        <b-tab>
            <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                    <i class="bx bx-book-content"></i>
                </span>
                <span class="d-none d-sm-inline-block"><i class="bx bx-book-content me-1"></i>Available</span>
            </template>
            <BursList 
                type="available"
                :loading="loading"
                :list="bursData"
                @editBurs="editBurs"
                @createDisbursement="createDisbursement"
                @generateDV="generateDV"
                @attachment="getAttachments"
                @printBurs="printBurs($event)"
            />
        </b-tab>
        <b-tab>
            <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                    <i class="bx bx-layer text-info"></i>
                </span>
                <span class="d-none d-sm-inline-block"><i class="bx bx-layer me-1"></i>Submitted</span>
            </template>
            <DisbursementList 
                type="submitted"
                :loading="loading"
                :tableData="disbursementData"
                :journals="journals"
                @generateDV="generateDV"
                @post="approveDV"
                @attachment="getAttachments"
                @editDisbursement="editDisbursement"
                @deleteDisbursement="deleteDisbursement"
            />
        </b-tab>
        <b-tab>
            <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                    <i class="bx bx-spreadsheet text-info"></i>
                </span>
                <span class="d-none d-sm-inline-block"><i class="bx bx-check me-1"></i>Approved</span>
            </template>
            <DisbursementList 
                type="posted"
                :loading="loading"
                :tableData="disbursementData"
                :journals="journals"
                @returnDisbursement="returnDisbursement"
                @generateDV="generateDV"
                @attachment="getAttachments"
            />
        </b-tab>
    </b-tabs>
    <print-options ref="printOpt"></print-options>
    <DisbursementModal 
        ref="disbursementModal"
        :modalTitle="modalTitle"
        :banks="banks"
        :accounts="accounts"
        @submit="submitDisbursement"
    />
    <FinanceAttachments 
        ref="finAttach"
        :wActions="true"
    />
    <BursModal :modalTitle="modalTitle" ref="bursModal" @submit="submitBurs" />
  </Layout>
</template>